import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MediaFile } from 'src/app/utils/common-classes';
import { MatDialogRef } from '@angular/material';
export class MoveFilesDialogComponent {
    constructor(dialogRef, data, fileService, utils) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fileService = fileService;
        this.utils = utils;
    }
    ngOnInit() {
    }
    onAbortClick() {
        this.dialogRef.close(null);
    }
    onSelectClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            let files = _self.data.files;
            if (!files || files.length <= 0) {
                let message = yield _self.utils.translateKey("dialog.move-files.error.no-file-selected-error");
                _self.utils.showErrorToast(message);
                return Promise.resolve();
            }
            _self.utils.showShortLoader();
            let errors = [];
            let movedFiles = [];
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                let mediaFile = new MediaFile();
                mediaFile.mediaFileId = file.mediaFileId;
                mediaFile.mediaFolderId = _self.selectedFolder.mediaFolderId;
                try {
                    let movedFile = yield _self.fileService.editFile(mediaFile);
                    movedFiles.push(movedFile);
                }
                catch (err) {
                    console.error("move file error", file);
                    errors.push(file);
                }
            }
            if (errors.length > 0) {
                let filesList = "";
                for (let i = 0; i < errors.length; i++) {
                    filesList += errors[i].name;
                    if (i + 1 != errors.length) {
                        filesList += ", ";
                    }
                }
                let message = yield _self.utils.translateKeyWithData("dialog.move-files.error.move-error", { files: filesList });
                _self.utils.showErrorToast(message);
            }
            else {
                let message = yield _self.utils.translateKey("dialog.move-files.success.move-success");
                _self.utils.showToast(message);
            }
            _self.utils.hideShortLoader();
            _self.dialogRef.close(movedFiles);
        });
    }
    selectFolder(node) {
        let _self = this;
        _self.selectedFolder = node;
    }
}
